import {httpClient} from "./httpClient";

export type GeneratedAddress = {
    id: string;
    generated_address: string;
    original_address: string;
    address_type: number;
    wif_private_key: string;
    hex_private_key: string;
    balance: number;
    prefix_generation: boolean;
    machine_guid: string;
    ip_address: string;
    created_at: string;
    updated_at: string;
};

export type GetGeneratedAddressesRequest = {
    take: number;
    offset: number;
    sort_by: "created_at" | "address_type" | "original_address" | "balance";
    sort_order: "asc" | "desc";
};

export type GetGeneratedAddressesResponse = {
    items: GeneratedAddress[];
    total: number;
};

export async function getGeneratedAddresses(
    params: GetGeneratedAddressesRequest
): Promise<GetGeneratedAddressesResponse> {
    const {data} = await httpClient.post<GetGeneratedAddressesResponse>(
        "/generatedAddress/getList",
        params
    );
    return data;
}

export type ExportFilter = "all" | "with_balance";

export async function exportGeneratedAddresses(filter: ExportFilter = "all"): Promise<void> {
    const response = await httpClient.post("/generatedAddress/export", {filter}, {
        responseType: "blob",
    });

    const disposition = response.headers["content-disposition"];
    let filename = "private_keys.txt";
    if (disposition) {
        const match = disposition.match(/filename="?([^";\n]+)"?/);
        if (match?.[1]) filename = match[1];
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

